// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import VerticalRightOutlinedSvg from "@fishx/icons-svg/es/asn/VerticalRightOutlined";
import FishxIcon from '../components/FishxIcon';

var VerticalRightOutlined = function VerticalRightOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: VerticalRightOutlinedSvg
  }));
};

VerticalRightOutlined.displayName = 'VerticalRightOutlined';
export default React.forwardRef(VerticalRightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/VerticalRightOutlined.js
// module id = 4372
// module chunks = 0